<template>
    <div class="quantity-picker">
        <b-input-group size="sm" class="flex-nowrap">
            <b-input-group-prepend>
                <b-button variant="outline-danger" @click="onDecrement" :disabled="quantity <= 1">
                    <b-icon icon="chevron-down" />
                </b-button>
            </b-input-group-prepend>
            <b-form-input
                    v-model="quantity"
                    type="number"
                    min="1"
                    @blur="handleBlur"
            ></b-form-input>
            <b-input-group-append>
                <b-button variant="outline-success" @click="onIncrement">
                    <b-icon icon="chevron-up" />
                </b-button>
                <slot></slot>
            </b-input-group-append>

        </b-input-group>
    </div>
</template>

<script>
    export default {
        name: "QuantityPicker",
        props: ['initialQuantity', 'itemId'],
        data() {
            return {
                quantity: 1,
            };
        },
        created() {
            this.quantity = Number(this.initialQuantity);
        },
        methods: {
            handleBlur() {
                this.onSelectQuantity(Number(this.quantity));
            },
            onIncrement() {
                this.onSelectQuantity(Number(this.quantity) + 1);
            },
            onDecrement() {
                this.onSelectQuantity(Number(this.quantity) - 1);
            },
            onSelectQuantity(quantity) {
                this.quantity = quantity;

                if(quantity < 1) {
                    this.quantity = 1;
                }

                this.$emit('onSelectQuantity', {
                    itemId: this.itemId,
                    quantity: this.quantity
                });
            }
        }
    }
</script>

<style scoped>
    .quantity-picker {
        min-width: 110px;
    }

    .quantity-picker >>> input {
        text-align: center;
        width: 45px;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>